import { createContext, useContext, useMemo, useState } from "react";
import styled from "styled-components";
import { usePostCardContext } from "../../PostCardContent";
import { Image } from "./Image";
import { ImageContentProps } from "./imageContent";
import { useGetPostImages } from "./useGetPostImages";
import { WithCarousel } from "./WithCarousel";

const Context = createContext({} as ImageContentProps.Context);
export const useImageContentContext = () => useContext(Context);
export const ImageContent = () => {
  const {
    postId,
    isWithinRepostPost,
    onPostCardClicked,
    isOnExpandedPostView,
  } = usePostCardContext();
  const [carouselIndex, setCarouselIndex] = useState(0);

  const postImages = useGetPostImages({ postId });
  const Images = useMemo(() => {
    return postImages
      .map((image) => {
        if (!postImages || !postImages.length) return null;
        if (!image || !image.id) return null;
        return <Image key={image.id} image={image} />;
      })
      .filter((image) => image !== null) as JSX.Element[];
  }, [postImages]);
  if (!Images || !Images.length) return null;

  const showCarousel = Images.length > 1;

  return (
    <Context.Provider
      value={{
        Images,
        carouselIndex,
        setCarouselIndex,
        isWithinRepostPost,
      }}
    >
      <Container
        $isExpandedPostView={isOnExpandedPostView}
        onClick={onPostCardClicked}
      >
        <ImageWrapper
          className="image-wrapper"
          $isExpandedPostView={isOnExpandedPostView}
        >
          {showCarousel ? <WithCarousel /> : Images[0]}
        </ImageWrapper>
      </Container>
    </Context.Provider>
  );
};

const Container = styled.div<{ $isExpandedPostView: boolean }>`
  height: fit-content;
  display: flex;
  padding: ${({ theme, $isExpandedPostView }) =>
      $isExpandedPostView ? theme.spacing["spacing-2"].value : 0}rem
    ${({ theme, $isExpandedPostView }) =>
      $isExpandedPostView ? theme.spacing["spacing-4"].value : 0}rem;
`;
const ImageWrapper = styled.div<{
  $isExpandedPostView: boolean;
}>(({ $isExpandedPostView, theme }) => {
  if (!$isExpandedPostView) return `position:relative;width:100%`;

  return `
    position: relative;
    width:100%;
    height:100%;
    border-radius: ${theme.radius["radius-xs"].value}rem;
    border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-neutral"].value};
    background-color: ${theme.Color.border["ui-border-neutral"].value};

    
    gap: ${theme.spacing["spacing-2"].value}rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  `;
});
